// EDITORUX1 (docs/build-briefs/EDITORUX1-editors-discounts-brand.md, UX baseline finding 04): the one piece of script the
// franchisor editors share. The look (header, field rhythm, pinned footer, Cancel then Save) is the `.editor-*` block in
// styles.css; this file only builds the unsaved line every editor shows in its footer. The state itself stays where each
// editor already keeps it (a dirty flag, or a comparison with the values it opened with); nothing here stores a draft.

export interface UnsavedIndicator {
  element: HTMLElement;
  /** True shows "Unsaved changes"; false leaves the line empty. The element stays in the page so a screen reader hears the change. */
  set(dirty: boolean): void;
}

export const UNSAVED_TEXT = "Unsaved changes";

export function createUnsavedIndicator(): UnsavedIndicator {
  const element = document.createElement("span");
  element.className = "editor-unsaved";
  element.dataset["testid"] = "editor-unsaved";
  element.setAttribute("role", "status");
  element.setAttribute("aria-live", "polite");
  return {
    element,
    set(dirty: boolean): void {
      const text = dirty ? UNSAVED_TEXT : "";
      if (element.textContent !== text) element.textContent = text;
      element.classList.toggle("is-dirty", dirty);
    },
  };
}
